import React, { ReactNode } from "react";
import classNames from "classnames";

type Props = {
  auth?: boolean;
  light?: boolean;
  full?: boolean;
  account?: boolean;
  children: ReactNode;
};

const Layout: React.FC<Props> = ({ children, auth, light, account, full }) => {
  const className = classNames("layout", {
    layout__auth: auth,
    layout__light: light,
    layout__account: account,
    layout__full: full,
  });

  return <div className={className}>{children}</div>;
};

export default Layout;
